module.exports = __webpack_public_path__ + "static/img/sport_1.b63aa82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport_1.png
// module id = rf9q
// module chunks = 0